import { ProductCard } from '@/components/blocks/HelloRetailProductCard';
import { cardNameSx } from "@/components/content/CatalogEntryList/styles/container";
import { gridItemProductCardSx } from "@/components/content/CatalogEntryList/styles/productGrid";
import { useHelloRetailProductRecommendations } from "@/data/Content/HelloRetailProductRecommendations";
import { useHelloRetailSearch } from "@/data/Content/HelloRetailSearch";
import { ContentContext } from "@/data/context/content";
import { useDeviceType } from '@/data/deviceDetection';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import { Grid, Stack, Typography } from "@mui/material";
import { FC, useContext, useEffect, useState } from "react";
import { HelloRetailCategoryList } from './CategoryList';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';

export const PopularProducts: FC = () => {
    const { settings } = useSettings();
    const { products } = useHelloRetailProductRecommendations({"recommendationBoxId":settings.userData.HelloRetailPopularProductsBoxId}, "other_page");
    const { helloRetailClickTracking, searchValue, products: searchedProducts, loading: searchLoading } = useContext(ContentContext) as ReturnType<typeof useHelloRetailSearch>;
    const labelsNLS = useLocalization("Header").HelloRetail.PopularProducts;

    const [showNotFoundMsg, setNotFoundMsg] = useState(false);
    useEffect(() => {
        let timeOut: NodeJS.Timeout;
        if (searchValue && !searchedProducts?.length && !searchLoading) {
            timeOut = setTimeout(() => setNotFoundMsg(true), 500)
        } else {
            setNotFoundMsg(false);
        }
        return () => clearTimeout(timeOut);
    }, [searchValue, searchedProducts, searchLoading]);

    const { isMobile } = useDeviceType();

    return (
        <Stack justifyContent="center" alignItems="center" rowGap={2}>
            <HelloRetailCategoryList styles={{container:{justifySelf:'center', width : isMobile ? '100%' : '70%'}}} />
            {showNotFoundMsg ? 
                <Stack width={isMobile ? "100%" : "70%"} rowGap={1.5} mb={1}>
                    <Typography sx={{fontFamily:'mikado-bold', fontSize:'18px !important'}}>
                        {labelsNLS.NoSearchResultsMsgHeading.t([searchValue])}
                    </Typography>
                    <Typography >{labelsNLS.NoSearchResultsMsg.t()}</Typography>
                </Stack> 
            : null}
             {!showNotFoundMsg ? 
                <ContentRecommendation 
                    id="IT-Header-HelloRetail-Popular-Products-Heading"
                    properties={{emsName:"IT-Header-HelloRetail-Popular-Products-Heading"}}
                />
            :null}
            <Grid container width={isMobile ? "100%" : "70%"}>
                <Grid
                    container
                    item
                    spacing={3}
                    alignItems="stretch"
                    id="catalog-entry-list-product-grid"
                    data-testid="catalog-entry-list-product-grid"
                >
                    {products?.map((product, index) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                            key={`${product.id}-${product.thumbnail}-${index}`}
                            display="flex"
                            sx={gridItemProductCardSx}
                        >
                            <ProductCard
                                product={product}
                                styles={{ cardNameSx }}
                                imgLoading={index < 4 ? 'eager' : 'lazy'}
                                clickAction={helloRetailClickTracking}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Stack>
    );
}